// extracted by mini-css-extract-plugin
export default {"task-item":"tasks_task-item__lHPHQ","task-completed":"tasks_task-completed__Rd3rT","button":"tasks_button__BztWH","task-input-field":"tasks_task-input-field__EKgra"};